import Vue from 'vue'
import axios from '@/utils/request';
import _ from 'lodash';

export const STATUS_SHOW = 10;
export const STATUS_HIDE = 20;

export const PINNED_YES = 10;
export const PINNED_NO = 20;

export const IMPORTANT_YES = 10;
export const IMPORTANT_DEFAULT = 20;

export default {
    state: {
        posts: []
    },
    mutations: {
        fetchPosts(state, payload) {
            state.posts = payload;
        },
        setPosts(state, payload) {
            state.posts = payload;
        },
        addPostsToList(state, payload) {
            // fix to prevent double insert(from http and Socket.io), check is time sheet already inserted (by this application instance)
            let timesheet = _.find(state.posts, p => p.id == payload.id);
            if (timesheet) {
                return; // exit
                //? or pass to update
            }

            state.posts.unshift(payload);
        },
        editPost(state, payload) {
            const index = state.posts.findIndex(item => item.id === payload.id);
            Vue.set(state.posts, index, payload);
        },
        deletePost(state, payload) {
            state.posts.map((post,index) => {
                if (post.id == payload.id) {
                    state.posts.splice(index,1);
                }
            })
        },
    },
    actions: {
        async fetchPosts({ commit, dispatch }) {
            commit('clearError')
            commit('setLoading', true)

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.get(`${this._vm.appConfig.app_url}/api/newsFeed`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('fetchPosts', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },
        async createNewPost({commit, dispatch}, payload) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.post(`${this._vm.appConfig.app_url}/api/newsFeed`, payload, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('addPostsToList', data);
                return data;
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }

                throw error
            }
        },
        async editPost({commit, dispatch}, formData) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                formData.append('_method', 'PATCH'); //! put not working on FormData, -> use PATCH && post
                let { data } = await axios.post(`${this._vm.appConfig.app_url}/api/newsFeed/${formData.get('id')}`, formData, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('editPost', data)
                commit('setLoading', false)
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }

                throw error
            }
            // --
            commit('clearError')
            commit('setLoading', true)
        },
        async deletePost({commit, dispatch}, payload) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.delete(`${this._vm.appConfig.app_url}/api/newsFeed/${payload.id}`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('deletePost', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }

                throw error
            }
        },
        async changeStatus({commit, dispatch}, payload) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.post(`${this._vm.appConfig.app_url}/api/newsFeed/changeStatus/${payload.id}`, {status: payload.status}, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('editPost', data)
                commit('setLoading', false)
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }

                throw error
            }
        },
        async changePinned({commit, dispatch}, payload) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.post(`${this._vm.appConfig.app_url}/api/newsFeed/changePinned/${payload.id}`, {pinned: payload.pinned}, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('editPost', data)
                commit('setLoading', false)
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }

                throw error
            }
        },

    },
    getters: {
        posts (state) {
            return state.posts
        },
    }
}